<p style="margin-bottom: 0.42cm">
  <b>Software Assurance Policy</b>
</p>

<P CLASS="western" STYLE="margin-bottom: 0.42cm">4D Monitoring Ltd (&ldquo;<B>We</B>&rdquo;) are committed to ensuring the accuracy of your data.</P>

<P STYLE="margin-left: 1.27cm; text-indent: -1.27cm; margin-bottom: 0.42cm">
  <B>Logging</B>
</P>

Telemetry is logged at the initial API endpoint and raw packet data stage, captured during transformation into the required format, and logged upon insertion into the database. Data integrity checks for each sensor type are performed regularly to ensure accuracy, with database values cross-referenced against their raw format.

<P STYLE="margin-left: 1.27cm; text-indent: -1.27cm; margin-bottom: 0.42cm">
  <B>End to End testing</B>
</P>

End-to-end testing analyses data from sensors to user-facing dashboards, with snapshots of HTML views cross-referenced against expected values. Manual spot checks are conducted regularly to ensure automated systems remain accurate and up-to-date with software updates.

<P STYLE="margin-left: 1.27cm; text-indent: -1.27cm; margin-bottom: 0.42cm">
  <B>Performance testing</B>
</P>

Performance testing evaluates the system's ability to handle peak loads, focusing on lag during traffic spikes. We verify that internal systems offload unprocessed packets and ensure delayed packets are successfully ingested into the system regularly.
